import React, {useCallback, useContext, useRef, useState} from 'react';
import {
  DashboardLayout,
  PrimaryButton,
  SecondaryButton,
} from '../../../components';
import {useNavigate} from 'react-router-dom';
import {Constants} from '../../../helpers';
import {
  // chevronRight,
  closeWidget,
  // easyAuthenticationMobile,
  edit,
  logo,
  widgetBack,
} from '../../../assets/images/images';
import ConfigPanel from './ConfigPanel';
import {EasyOnboardContext} from '../../../helpers/context';
import {useMutation, useQueryClient} from 'react-query';
import {createAuthWidget} from '../../../requests/queries/easyAuth';
import {toast} from 'react-toastify';
import * as MainAssets from '../../../assets/images/images';
import inverseColor from '../../../helpers/colorInversion';
import {useSelector} from 'react-redux';
import Breadcrumbs from 'components/BreadCrumbs';
import {PAGES_URL} from 'helpers/constants';

function CreateAuthFlow() {
  const textAreaRef = useRef(null);
  const [selectedApp, setSelectedApp] = useState('');
  const [type, setType] = useState('draft');
  const {singleApp} = useSelector(state => state?.widgets);

  const {easyAuthWidgetData, setEasyAuthWidgetData} =
    useContext(EasyOnboardContext);
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const handleFocus = () => {
    textAreaRef.current.focus();
  };

  const {mutate, isLoading} = useMutation(createAuthWidget);

  const handleCreateWidget = useCallback(
    async type => {
      setType(type);
      const newType = type === 'draft' ? '' : type;
      try {
        const data = {
          app: selectedApp,
          ...easyAuthWidgetData,
          published: !!newType,
        };
        const message =
          type === 'publish'
            ? 'Auth Widget published successfully'
            : 'Auth Widget saved successfully';
        await mutate(data, {
          onSuccess: widget => {
            toast.success(message);
            queryClient.invalidateQueries();
            navigate(
              Constants.PAGES_URL.AUTHENTICATION_FLOW_UPDATE?.replace(
                ':slug',
                widget?.widget?._id,
              ),
            );
          },
          onError: error => {
            toast.error(error?.response?.data?.error);
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
    [easyAuthWidgetData, mutate, navigate, queryClient, selectedApp],
  );

  return (
    <DashboardLayout
      className="!mb-0"
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">
          Easy Authentication
        </p>
      }
      // breadCrumbs={
      //   <div className="flex items-center">
      //     <img src={easyAuthenticationMobile} alt="" width={18} height={18} />
      //     <Link
      //       to={Constants.PAGES_URL.}
      //       className="ml-2 -mb-1"
      //     >
      //       Easy Authentication
      //     </Link>
      //     <img src={chevronRight} alt="" width={18} height={18} />
      //     <p className="-mb-1 cursor-pointer">Create a flow</p>
      //   </div>
      // }
    >
      <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mx-[-32px] px-8 border border-transparent border-b-[#E4E4E6]">
        <Breadcrumbs
          items={[
            {
              label: 'Easy Authentication',
              path: PAGES_URL.AUTHENTICATION_FLOW,
            },
            {label: 'Create a Flow'},
          ]}
        />
      </div>
      <div className="flex gap-[3.72%] bg-[#f9f9f9] basis-full h-full mx-[-32px]">
        <div className="w-full basis-[30.709%] flex flex-col h-screen pl-8">
          <div className="flex items-center gap-1 mt-6">
            <input
              ref={textAreaRef}
              className="text-base font-medium text-grey outline-none focus:outline focus:outline-offset-2 focus:outline-1 placeholder:italic"
              type="text"
              placeholder="Widget flow name here..."
              style={{
                maxWidth: 350,
                maxHeight: 50,
                border: 'none',
              }}
              onChange={e => {
                setEasyAuthWidgetData({
                  ...easyAuthWidgetData,
                  name: e.target.value,
                });
              }}
            />
            <img
              src={edit}
              onClick={handleFocus}
              alt=""
              className="cursor-pointer ml-2 mt-2"
            />
          </div>
          <div className="mt-6 overflow-y-auto custom-flow">
            <ConfigPanel setSelectedApp={setSelectedApp} />
          </div>
        </div>

        <div className="bg-black25 basis-[65.571%] custom-flow overflow-y-auto">
          <div className="bg-white80 relative flex w-full right-0 items-center gap-4 py-2 px-12 justify-end">
            <SecondaryButton
              buttonText="Save as Draft"
              btnHeight="h-7"
              yPadding="pt-[9px] pb-[10px]"
              className="text-xs"
              loading={type === 'draft' && isLoading}
              onClick={() => handleCreateWidget('draft')}
              disabled={easyAuthWidgetData?.name?.length === 0}
            />
            <PrimaryButton
              buttonText="Publish"
              xPadding="px-5"
              yPadding="py-2"
              fontSize="text-xs"
              className="h-7"
              onClick={() => handleCreateWidget('publish')}
              disabled={easyAuthWidgetData?.name?.length === 0}
              loading={type === 'publish' && isLoading}
            />
          </div>

          <div
            className="min-h-screen"
            style={{
              opacity: 1,
              transition: 'opacity 0.3s ease-in-out',
            }}
          >
            <div className="flex flex-col items-center justify-center max-w-lg mx-auto h-screen py-4 mt-8">
              <div className="flex flex-col items-center w-full px-6 py-8 bg-white rounded-lg">
                <div className="flex justify-between w-full">
                  <button disabled>
                    <img src={widgetBack} alt="" className="pt-4 pl-4" />
                  </button>
                  <button disabled>
                    <img src={closeWidget} alt="" className="pt-4 pr-4" />
                  </button>
                </div>
                <header className="flex flex-col items-center mt-2">
                  <img
                    src={singleApp?.logo || MainAssets.logo}
                    alt=""
                    className="max-h-10"
                  />
                </header>
                <p className="text-grey font-medium mt-2">Say cheese!</p>
                <div className="mt-2 px-2 py-1 bg-[#BFD3F3] rounded-2xl">
                  <p className="text-[#0D192C] text-xs">This looks good</p>
                </div>

                <img
                  src={MainAssets.SmilingPhoto}
                  alt="smiling"
                  className="w-[246px] h-[246px] rounded-full mt-4"
                />

                <div className="mt-6 px-2 py-1 bg-[#F8EBEA] rounded-2xl flex items-center gap-2">
                  <img src={MainAssets.infoRed} alt="red" />
                  <p className="text-[#B42318] text-xs mt-[2px]">
                    Please make sure your are in a well lit environment
                  </p>
                </div>

                <button
                  disabled
                  className="w-full h-12 max-w-sm mt-6 font-medium  rounded text-tiny bg-brandBlue"
                  style={{
                    backgroundColor:
                      singleApp?.color || singleApp?.color_code || '',
                    color: inverseColor(
                      singleApp?.color || singleApp?.color_code || '#ffffff',
                    ),
                  }}
                >
                  Continue
                </button>

                <div className="flex items-center justify-center gap-2 my-4">
                  <span className="text-sm text-grey">Powered by</span>
                  <img src={logo} alt="" width={30.55} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default CreateAuthFlow;
